import React, { useState } from 'react';
import { Link, NavLink, Navigate, useParams } from 'react-router-dom';
import { Icon } from '@iconify/react';
import MasterLayout from '../../masterLayout/MasterLayout';
import Breadcrumb from '../../components/Breadcrumb';
import KkpAdminPackAssoSection from '../../components/kkp/admin/KkpAdminPackAssoSection';
import KkpAdminMagSection from '../../components/kkp/admin/KkpAdminMagSection';
import KkpAdminSetSection from '../../components/kkp/admin/KkpAdminSetSection';
import KkpAdminNewsletterSection from '../../components/kkp/admin/KkpAdminNewsletterSection';
import KkpAdminStatutsSection from '../../components/kkp/admin/KkpAdminStatutsSection';
import KkpAdminPriceExportModal from '../../components/kkp/admin/KkpAdminPriceExportModal';
import KkpAdminChiffrageSection from '../../components/kkp/admin/KkpAdminChiffrageSection';
import KkpAdminKlubSection from '../../components/kkp/admin/KkpAdminKlubSection';
import { AppButton } from '../../components/ui';
import { ROUTES } from '../../config/routes';
import '../../styles/admin-nav.scss';

const SECTIONS = [
  { id: 'pack-asso', label: 'Pack Asso', icon: 'mdi:package-variant-closed', hint: 'Formules association, tarif HT' },
  { id: 'mag', label: 'MAG', icon: 'mdi:newspaper-variant-outline', hint: 'Formats & contenus magazine' },
  { id: 'set', label: 'SET', icon: 'mdi:calendar-month-outline', hint: 'Formats agenda (10 lignes / mois)' },
  { id: 'newsletter', label: 'Newsletters', icon: 'mdi:email-newsletter', hint: 'Types & emplacements' },
  { id: 'klub', label: 'Klub', icon: 'mdi:card-account-details-star-outline', hint: 'Offres et tarifs Klub / Klub CE' },
  { id: 'chiffrage', label: 'Chiffrage Koikispass', icon: 'mdi:calendar-month-outline', hint: 'Tarifs, frais techniques & produits BDC' },
  { id: 'statuts', label: 'Statuts phase', icon: 'mdi:traffic-light', hint: 'Communs MAG, SET & Newsletters' },
];

const SECTION_COMPONENTS = {
  'pack-asso': KkpAdminPackAssoSection,
  mag: KkpAdminMagSection,
  set: KkpAdminSetSection,
  newsletter: KkpAdminNewsletterSection,
  klub: KkpAdminKlubSection,
  chiffrage: KkpAdminChiffrageSection,
  statuts: KkpAdminStatutsSection,
};

const KkpAdminPage = () => {
  const { section = 'mag' } = useParams();
  const [priceExportOpen, setPriceExportOpen] = useState(false);
  const validSection = SECTIONS.some((s) => s.id === section && !s.external) ? section : 'mag';
  const currentMeta = SECTIONS.find((s) => s.id === validSection);
  const SectionComponent = SECTION_COMPONENTS[validSection] ?? KkpAdminMagSection;

  if (section === 'commerciaux') {
    return <Navigate to={ROUTES.admin.commerciaux} replace />;
  }

  if (section !== validSection) {
    return <Navigate to={ROUTES.kkp.adminSection(validSection)} replace />;
  }

  return (
    <MasterLayout>
      <Breadcrumb
        title="Administration Koikispass"
        subtitle="Référentiels des plannings et tarifs"
        actions={(
          <>
            <AppButton
              size="sm"
              variant="danger-600"
              icon="mdi:file-pdf-box"
              onClick={() => setPriceExportOpen(true)}
            >
              Exporter les prix
            </AppButton>
            <AppButton as={Link} to={ROUTES.kkp.planningMag} size="sm" variant="outline-secondary">Retour Koikispass</AppButton>
          </>
        )}
      />

      <div className="row g-4">
        <div className="col-lg-3">
          <div className="card admin-nav-card admin-nav-card--kkp kkp-admin-nav-card">
            <div className="card-body p-0">
              <div className="list-group list-group-flush">
                {SECTIONS.map((s) => (
                  <NavLink
                    key={s.id}
                    to={ROUTES.kkp.adminSection(s.id)}
                    className={({ isActive }) => `list-group-item list-group-item-action d-flex align-items-start gap-2 border-0 ${isActive ? 'active' : ''}`}
                  >
                    <Icon icon={s.icon} className="mt-1 flex-shrink-0" width={20} />
                    <span>
                      <span className="d-block fw-semibold">{s.label}</span>
                      <small className={`d-block ${validSection === s.id ? '' : 'text-secondary-light'}`}>{s.hint}</small>
                    </span>
                  </NavLink>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-9">
          <div className="card">
            <div className="card-header bg-base d-flex align-items-center gap-2">
              <Icon icon={currentMeta?.icon} width={22} />
              <h6 className="mb-0 fw-semibold">{currentMeta?.label}</h6>
            </div>
            <div className="card-body">
              <SectionComponent />
            </div>
          </div>
        </div>
      </div>

      <KkpAdminPriceExportModal show={priceExportOpen} onClose={() => setPriceExportOpen(false)} />
    </MasterLayout>
  );
};

export default KkpAdminPage;
